<template>
  <el-row class="container">
    <el-col :md="24" class="header">
      <el-collapse-transition>
        <el-col v-show="!data.collapsed" :md="10" class="logo"
                :class="[data.collapsed?'logo-collapse-width':'logo-width', isBoa ? 'is-br' : '']">
          <el-image
            @click="gotodashboard"
            :src="getImage()"
            fit="fit"
          style="margin-top: 4px; cursor: pointer"/>
        </el-col>
      </el-collapse-transition>
      <el-col :md="2" :lg="2" :sm="2" :xs="4">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>
      <el-col :md="10" :lg="12" :sm="9" :xs="6">
        <el-menu
          :default-active="selectedParentMenu.toString()"
          class="el-menu-demo hidden-xs-only"
          mode="horizontal"
          @select="handleSelectTopBarMenu">
         <el-menu-item :key="`${index + 1}`" :index="`${index + 1}`" v-for="(item, index) in parents">
           <i :class="item.icon"></i><span class="hidden-md-only hidden-sm-only">{{$t(item.title)}}</span>
         </el-menu-item>
             <el-menu-item style="color:white;cursor: pointer;opacity: 1" @click="enableIntroduction;handleSelectTopBarMenu(4)" v-if="data.isIntroductionEnabled !== false">
                 <i class="fa fa-newspaper-o"></i>
                 <span class="hidden-md-only hidden-sm-only">{{$t('menu.introduction')}}</span>
             </el-menu-item>
             <el-menu-item disabled style="color:white;cursor: pointer;opacity: 1" v-if="data.isNewsEnabled !== false && isAsia">
                 <ElLink :href="this.newsURL"
                    target="_blank"
                    class="news-link"
                    :underline="false"
                    style="color:white;cursor: pointer;opacity: 1; font-weight: normal"
                    >
                     <i class="fa fa-bullhorn"></i>
                     <span class="hidden-md-only hidden-sm-only">{{$t('menu.menu_news')}}</span>
                 </ElLink>
             </el-menu-item>
        </el-menu>
        <ElSelect :value="selectedParentMenu === -1 ? '':selectedParentMenu" @change="handleSelectTopBarMenu" class="hidden-sm-and-up">
          <ElOption
            v-for="(item, index) in parents"
            :key="item.id"
            :label="$t(item.title)"
            :value="item.id">
            <span><i :class="item.icon"></i> {{ $t(item.title) }}</span>
          </ElOption>
          <ElOption :value=4 :label="$t('menu.introduction')" @click.native="enableIntroduction" @change="handleSelectTopBarMenu(4)" v-if="data.isIntroductionEnabled !== false">
            <span><i class="fa fa-newspaper-o"></i> {{$t('menu.introduction')}}</span>
          </ElOption>
          <ElOption disabled style="color:white;cursor: pointer;opacity: 1" v-if="data.isNewsEnabled !== 'false' && isAsia">
            <ElLink :href="this.newsURL"
               target="_blank"
               class="news-link"
                :underline="false"
                style="color:white;cursor: pointer;opacity: 1; font-weight: normal">
              <i class="fa fa-bullhorn"></i>
              <span class="hidden-md-only hidden-sm-only">{{$t("menu_news")}}</span>
            </ElLink>
          </ElOption>
        </ElSelect>
      </el-col>
      <!--<el-col :lg="3" :md="3" :sm="4" :xs="2" :offset="6">
        <ElDropdown trigger="hover" size="medium" @command="changeLang">
          <span class="el-dropdown-link userinfo-inner">
            <div class="block text-right">
              <i class="fa fa-language"></i> {{$t('forms.language')}} - {{ $i18n.i18next.language === 'en' ? $t('lookups.lang_english'): $t('lookups.lang_japanese')}}
            </div>

          </span>
          <template v-slot:dropdown>
            <ElDropdownMenu>
              <ElDropdownItem command="en">{{$t('lookups.lang_english')}}</ElDropdownItem>
              <ElDropdownItem command="jp">{{$t('lookups.lang_japanese')}}</ElDropdownItem>
            </ElDropdownMenu>
          </template>
        </ElDropdown>
      </el-col>-->
     <el-col :md="5" :sm="6" :xs="12" class="aux">
       <el-row :gutter="0">
         <el-col :lg="16" :md="14" :sm="16" :xs="12" class="lang-dropdown text-right">
           <ElDropdown trigger="hover" size="medium" @command="changeLang">
          <span class="lang-select el-dropdown-link">
            <div class="block text-right">
              <!-- <i class="fa fa-language"></i><p class="lang-select-label"> {{$t('forms.language')}} - {{ $i18n.i18next.language === 'en' ? $t('lookups.lang_english'): $t('lookups.lang_japanese')}}</p> -->
              <div class="lang-select-label"><i class="fa fa-language"></i> {{$t('forms.language')}} - {{ $t(languageLookup) }}</div>
            </div>
          </span>
             <template v-slot:dropdown>
               <ElDropdownMenu>
                <ElDropdownItem command="en">{{$t('lookups.lang_english')}}</ElDropdownItem>
                <ElDropdownItem v-if="isBoa" command="br">{{ $t('lookups.lang_portuguese') }}</ElDropdownItem>
                <ElDropdownItem v-else command="jp">{{ $t('lookups.lang_japanese') }}</ElDropdownItem>
               </ElDropdownMenu>
             </template>
           </ElDropdown>
         </el-col>
         <el-col :lg="8" :md="10" :sm="8" :xs="12" class="userinfo" :class="data.collapsed?'':'hide-in-mobile-view'">
           <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">
            <div class="block">
              <el-avatar :size="50" fit="fit"
                         style="width: 40px; height: 40px; margin-top: 10px" class="user-logo">
                <i class="fa fa-user fa-4x" aria-hidden="true"></i>
              </el-avatar>
            </div>

          </span>
             <template v-slot:dropdown>
               <el-dropdown-menu>
                 <el-dropdown-item disabled>{{$t('menu.username', {user: getCurentUser().username})}}</el-dropdown-item>
                 <el-dropdown-item divided @click.native="gotoUpdate"><i class="fa fa-user" aria-hidden="true"></i> {{$t('menu.menu_profile')}}</el-dropdown-item>
                 <el-dropdown-item @click.native="logout"><i class="fa fa-sign-out" aria-hidden="true"></i> {{$t('menu.menu_logout')}}</el-dropdown-item>
               </el-dropdown-menu>
             </template>
           </el-dropdown>
         </el-col>
       </el-row>
      </el-col>
    </el-col>
    <el-col :md="24" class="main">
      <aside :class="[data.collapsed?'menu-collapsed':'menu-expanded', isBoa?'is-br':'']" v-if="selectedParentMenu !== -1">
        <!--Navigation menu-->
        <el-menu :default-active="getActiveMenuIndex()" class="el-side-menu" :collapse="data.collapsed" router>
          <template v-for="(item, index) in menu">
            <el-menu-item v-if="item.visible !== false" :title="$t(item.title)" :index="`${index}`" :route="{ name: item.href }" @click="menuItemClick">
              <i :class="item.icon"></i>
              <template v-slot:title>{{$t(item.title)}}</template>
            </el-menu-item>
          </template>
        </el-menu>

        <!--Navigation menu - after folding -->
        <el-menu :default-active="getActiveMenuIndex()"
                 :class="[!data.collapsed?'expanded':'', 'el-menu-vertical']"
                 unique-opened router v-show="!data.collapsed">
          <template v-for="(item, index) in menu">
            <!--<el-submenu :index="index+''" v-if="!item.leaf">
              <template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
              <el-menu-item class="subs" v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
            </el-submenu>-->
            <el-menu-item v-if="item.visible !== false" :route="{ name: item.href }" :index="`${index}`"><i
              :class="item.icon"></i>{{$t(item.title)}}
            </el-menu-item>
          </template>
        </el-menu>
      </aside>
      <section class="content-container" id="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :md="24" class="breadcrumb-container hide-in-mobile-view" v-if="selectedParentMenu !== -1">
            <!--<strong class="title">{{$route.name}}</strong>-->
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                {{ getreadcrumbsName(item) }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col>
            <NewsBanners/>
          </el-col>
          <el-col :md="24" class="content-wrapper mobile-el-col-offset">
            <!--<transition name="fade" mode="out-in">-->
            <div class="el-col mobile-el-col-full">
              <router-view :key="$route.fullPath"></router-view>
            </div>
          <!--  </transition>-->
          </el-col>
        </div>
      </section>
    </el-col>
    <el-col>
      <TermsAndCondition @agree="agree" @disagree="disagree" ref="terms" />
    </el-col>
  </el-row>
</template>

<script>
import Cookies from 'js-cookie';
import {
    MenuStore, AuthorizationStore, Payload, NewsStore, MyaaffiliateStore, CommonsStore,
} from '@samclick-store-factory';
import {
  Component, Prop, Vue, mapState, Watch,
} from '@samclick-commons';
import { parents, subItems } from '@/assets/scripts/menu/menu';
import { SamclickSelect } from '@samclick-components';
import {_find, _capitalize, _isEmpty, _filter, _includes} from '@samclick-lodash';
import {
  AUTH_TOKEN, CURRENT_USER_LANG, getItem, IS_ADMIN, SHOW_BG,
} from '@/utils/localstorage-util';
import TermsAndCondition from '@/views/Login/TermsAndCondition.vue';
import NewsBanners from '@/views/Login/NewsBanners.vue';
import * as appStorageUtil from '@/utils/localstorage-util';
import { getLanguageLookup, isBoa } from '@/utils/common-utils';

@Component({
  name: 'Home',
  components: { SamclickSelect, TermsAndCondition, NewsBanners },
  computed: {
    ...mapState('menu', ['menu', 'selectedParentMenu']),
  },
  props: {
    testing: {
      type: String,
      default: '',
    },
  },
})
export default class Home extends Vue {
    data = {
      collapsed: true,
      activeIndex2: '1',
      urlNews: process.env.VUE_APP_NEWS_URL,
      urlNewsEn: 'https://www.vjgroupaffiliation.com/news/',
      isNewsEnabled: process.env.VUE_APP_NEWS_ENABLED,
      isIntroductionEnabled: appStorageUtil.getSessionItem(SHOW_BG),
    };

    languageLookup = '';

    isBoa = false;

    isAsia = false;

    newsURL = '';

    getActiveMenuIndex() {
      return MenuStore.getIndexOfSelectedMenu(this.$route.name).toString();
    }

    handleSelectTopBarMenu(key, keyPath) {
      MenuStore.selectParentMenu(parseInt(key));
    }

    // 退出登录
    logout() {
      AuthorizationStore.logout();
      this.$router.push({ name: 'login' });
    }

    // 折叠导航栏
    collapse() {
      this.data.collapsed = !this.data.collapsed;
    }

    gotoUpdate() {
      this.$router.push({ name: 'updateinfo' });
      MenuStore.selectParentMenu(-1);
    }

    menuItemClick(item) {
      if (item.route.name === this.$router.currentRoute.name) {
        this.$router.go();
        // this.$router.push({ name: 'cpa', query: { plan: 'private' } });
        // this.$router.replace(this.$router.currentRoute.fullPath);
      }
    // this.$router.replace({ name: 'cpa'});
    }

    @Watch('selectedParentMenu')
    menuChanged(val, oldVa) {
      if (!_isEmpty(this.menu)) {
        this.$router.push({ name: this.menu[0].href });
      }
    }

    beforeCreate() {
      if (!_isEmpty(this.$route.query) && this.$route.query.token) {
        const affToken = `${this.$route.query.token}`;
        Cookies.set(AUTH_TOKEN, affToken);
        AuthorizationStore.getMyDetails(new Payload({ token: affToken })).then((response) => {
          const affInfo = response.data;
          const selectedLang = affInfo.preferred_language;
          window.localStorage.setItem(CURRENT_USER_LANG, selectedLang);
          this.$i18n.i18next.changeLanguage(selectedLang);
          window.localStorage.setItem(IS_ADMIN, 'true');
        });
      }

      this.parents = parents;
      this.subItems = subItems;
    }

    enableIntroduction() {
      this.$router.push({ path: '/introduction/beginners' });
    }

    getreadcrumbsName(routerMatched) {
      const self = this;
      if (!routerMatched.name) {
        return '';
      }
      if (routerMatched.parent) {
        const resParent = _find(self.subItems, { href: routerMatched.name });
        return resParent ? this.$t(resParent.title) : _capitalize(routerMatched.name);
      }

      const res = _find(self.parents, { href: routerMatched.name });
      return res ? this.$t(res.title) : _capitalize(routerMatched.name);
    }

    changeLang(command) {
      this.$i18n.i18next.changeLanguage(command);
      window.localStorage.setItem(CURRENT_USER_LANG, command);
      if (command === 'jp') {
          this.newsURL = this.data.urlNews;
      }else{
          this.newsURL = this.data.urlNewsEn;
      }
    }

    gotodashboard() {
      this.$router.push({ name: 'dashboard' });
    }

    agree() {
      AuthorizationStore.saveAffiliateTerms(new Payload({})).then(() => {
        AuthorizationStore.getMyDetails();
      });
    }

    disagree() {
      AuthorizationStore.logout();
      this.$router.push({ name: 'login' });
    }

    beforeMount() {
      if (window.innerWidth > 991) {
        this.data.collapsed = false;
      }
      this.languageLookup = getLanguageLookup();
      this.isBoa = isBoa();
    }

    mounted() {
      AuthorizationStore.getMyDetails().then((response) => {
        let user = sessionStorage.getItem('user');
        if (user) {
          user = JSON.parse(user);
          this.data.sysUserName = user.name || '';
          this.data.sysUserAvatar = user.avatar || '';
        }
        if (!AuthorizationStore.currentLoggedUserInState.agreed_tos && _isEmpty(getItem(IS_ADMIN))) {
          this.openTerms();
        }
      });
     this.isAsiaAffiliate();

        if (this.$i18n.i18next.language === 'jp') {
            this.newsURL = this.data.urlNews;
        }else{
            this.newsURL = this.data.urlNewsEn;
        }
    }

    getCurentUser() {
      return AuthorizationStore.currentLoggedUserInState;
    }

    openTerms() {
      this.$refs.terms.toggleDialog(true);
    }

    getImage() {
      let loginLogo = require('@/assets/img/logo_header.png');
      if (process.env.VUE_APP_IS_BOA === 'true') {
        loginLogo = require('@/assets/img/boabet-red-icon.png');
      }

      return loginLogo;
    }

    async isAsiaAffiliate() {
        const response = await CommonsStore.getAffiliateSubscription();
        const userSubscription = response.data;
        this.isAsia = ['Global and Asia'].some(code => _includes(userSubscription, code));
    }

}
</script>

<style scoped lang="scss">
  @import "@/assets/themes/verajohn/index.scss";
</style>
